import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import { CompaireIcon, CompaireLockup } from "./CompaireMarks";

/**
 * Legacy prop-API wrapper around the inline-SVG marks in CompaireMarks.
 * Variants: "full"/"dark" → lockup in teal deep (light surfaces),
 * "white" → lockup re-tinted white (dark surfaces), "icon" → icon mark only.
 */
interface CompaireLogoProps {
  variant?: "full" | "icon" | "white" | "dark";
  size?: "sm" | "md" | "lg" | "xl" | "2xl";
  className?: string;
  linkToHome?: boolean;
  showTagline?: boolean;
}
const sizeClasses = {
  sm: "h-6",
  md: "h-8",
  lg: "h-10",
  xl: "h-14",
  "2xl": "h-20"
};
export function CompaireLogo({
  variant = "full",
  size = "md",
  className,
  linkToHome = true,
  showTagline = false
}: CompaireLogoProps) {
  const markClasses = cn(sizeClasses[size], "w-auto max-w-full");
  const mark = variant === "icon" ? (
    <CompaireIcon className={markClasses} />
  ) : (
    <CompaireLockup
      className={markClasses}
      style={variant === "white" ? { color: "#FFFFFF" } : undefined}
    />
  );
  const logoContent = <div className={cn("flex flex-col items-start", className)}>
      {mark}
      {showTagline && <span className="mt-1 text-xs text-muted-foreground tracking-wide">
          Pairing People with Opportunity™
        </span>}
    </div>;
  if (linkToHome) {
    return <Link to="/" className="focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 rounded-sm" aria-label="Compaire home">
        {logoContent}
      </Link>;
  }
  return logoContent;
}
export default CompaireLogo;
